import { tsUtils } from '@neo-one/ts-utils';
import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class ContinueStatementCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.ContinueStatement;
    }
    visitNode(sb, node, options) {
        const label = tsUtils.statement.getLabel(node);
        if (label !== undefined) {
            sb.context.reportUnsupported(label);
        }
        sb.emitHelper(node, options, sb.helpers.continue);
    }
}

//# sourceMappingURL=ContinueStatementCompiler.js.map
